import React from 'react';
import { bool, arrayOf } from 'prop-types';
import cx from 'classnames';
import segmentStatus from 'propTypes/segmentStatus';
import coord from 'propTypes/coord';

import styles from './SegmentPath.scss';

function SegmentPath({ latLngList, isActive, status }) {
  // eslint-disable-next-line global-require
  const { Polyline } = require('react-leaflet');
  return (
    <div>
      <Polyline
        className={cx(styles.outline, {
          [styles.isActive]: isActive,
        })}
        positions={latLngList}
      />
      {isActive &&
        <Polyline
          positions={latLngList}
          className={cx(
            styles.underline,
            styles[`status-${status}`],
            ([styles.isActive]: isActive)
          )}
        />}
      <Polyline
        positions={latLngList}
        className={cx(styles.line, styles[`status-${status}`], {
          [styles.isActive]: isActive,
        })}
      />
    </div>
  );
}

SegmentPath.propTypes = {
  latLngList: arrayOf(coord).isRequired,
  status: segmentStatus.isRequired,
  isActive: bool.isRequired,
};

export default SegmentPath;



// WEBPACK FOOTER //
// ./src/components/Map/MapComponents/SegmentPath/index.js